import React from "react";
import { currencyFormatterWithFractions } from "utility";

export const Expense = ({ expense, altText, currencyCode, children }) => (
  <p className={`expense-card__expense ${expense ? "" : "expense-card__expense--na"}`}>
    {expense ? currencyFormatterWithFractions(expense, currencyCode, 2) : altText}
    {children}
  </p>
);
